/** Shown in Settings; bump when something user-visible ships. */
export const APP_VERSION = "0.2.0";
